import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableNoSearchResultsIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 160,
	height: 134,
	viewBox: "0 0 160 134",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M80 133.578C124.183 133.578 160 128.931 160 123.197C160 117.464 124.183 112.816 80 112.816C35.8172 112.816 0 117.464 0 123.197C0 128.931 35.8172 133.578 80 133.578Z",
			fill: "#F0F1F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M144.607 95.8204L64.3843 83.9893C61.9811 83.635 60.3203 81.3994 60.6746 78.9962L69.2498 20.8492C69.6041 18.4459 71.8397 16.7851 74.243 17.1394L154.466 28.9705C156.869 29.3248 158.53 31.5604 158.176 33.9637L149.6 92.1107C149.246 94.5139 147.01 96.1747 144.607 95.8204Z",
			fill: "#F0F1F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M140.675 90.2296L60.2163 100.334C57.8059 100.637 55.6069 98.9281 55.3041 96.5177L47.9801 38.1997C47.6773 35.7893 49.3858 33.5899 51.7962 33.2875L132.255 23.1832C134.665 22.8804 136.865 24.5889 137.167 26.9993L144.491 85.3174C144.794 87.7274 143.085 89.9268 140.675 90.2296Z",
			fill: "#F0F1F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.8913 95.8071C61.5251 95.8531 61.1908 95.5933 61.1451 95.2271L54.3705 41.2831C54.3245 40.9169 54.5843 40.5826 54.9504 40.5365C55.3166 40.4905 55.6509 40.7503 55.697 41.1164L62.4715 95.0605C62.5169 95.427 62.2575 95.761 61.8913 95.8071Z",
			fill: "#DDDEE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.2432 94.5743C69.877 94.6204 69.5427 94.3606 69.4966 93.9944L62.7221 40.0503C62.676 39.6842 62.9358 39.3498 63.302 39.3041C63.6682 39.2581 64.0025 39.5179 64.0482 39.884L70.8228 93.8281C70.8692 94.1942 70.6094 94.5282 70.2432 94.5743Z",
			fill: "#DDDEE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.5928 93.3403C78.2266 93.3863 77.8923 93.1265 77.8462 92.7604L71.0717 38.8163C71.0256 38.4501 71.2854 38.1158 71.6516 38.0697C72.0178 38.0237 72.3521 38.2835 72.3978 38.6496L79.1724 92.5937C79.2188 92.9599 78.959 93.2942 78.5928 93.3403Z",
			fill: "#D6D6D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.9424 92.1059C86.5763 92.152 86.2419 91.8921 86.1959 91.526L79.4213 37.5819C79.3752 37.2158 79.635 36.8814 80.0012 36.8354C80.3674 36.7893 80.7017 37.0491 80.7478 37.4153L87.5223 91.3593C87.5684 91.7258 87.3089 92.0598 86.9424 92.1059Z",
			fill: "#D6D6D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.2956 90.8712C94.9294 90.9172 94.5951 90.6574 94.5494 90.2913L87.7748 36.3472C87.7288 35.981 87.9886 35.6467 88.3547 35.601C88.7209 35.5549 89.0552 35.8147 89.1009 36.1809L95.8755 90.125C95.9212 90.4911 95.6618 90.8251 95.2956 90.8712Z",
			fill: "#DDDEE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.645 89.6371C103.279 89.6832 102.945 89.4234 102.899 89.0572L96.1244 35.1132C96.0784 34.747 96.3382 34.4127 96.7043 34.3666C97.0705 34.3206 97.4048 34.5804 97.4506 34.9465L104.225 88.8906C104.271 89.2571 104.011 89.5914 103.645 89.6371Z",
			fill: "#DDDEE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.995 88.4047C111.629 88.4508 111.294 88.191 111.249 87.8248L104.474 33.8808C104.428 33.5146 104.688 33.1803 105.054 33.1342C105.42 33.0881 105.754 33.3479 105.8 33.7141L112.575 87.6581C112.621 88.0247 112.361 88.3586 111.995 88.4047Z",
			fill: "#DDDEE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.344 87.17C119.978 87.2161 119.644 86.9563 119.598 86.5901L112.824 32.646C112.778 32.2799 113.037 31.9456 113.404 31.8998C113.77 31.8538 114.104 32.1136 114.15 32.4797L120.924 86.4238C120.97 86.7899 120.711 87.1239 120.344 87.17Z",
			fill: "#DDDEE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.694 85.9356C128.328 85.9817 127.994 85.7219 127.948 85.3557L121.173 31.4117C121.127 31.0455 121.387 30.7112 121.753 30.6654C122.119 30.6194 122.454 30.8792 122.499 31.2454L129.274 85.1894C129.32 85.5556 129.061 85.8899 128.694 85.9356Z",
			fill: "#DDDEE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.046 84.7016C136.679 84.7476 136.345 84.4878 136.299 84.1217L129.525 30.1776C129.479 29.8115 129.739 29.4771 130.105 29.4311C130.471 29.385 130.805 29.6448 130.851 30.011L137.625 83.955C137.671 84.3215 137.412 84.6555 137.046 84.7016Z",
			fill: "#DDDEE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.6113 31.3009L131.209 23.0003C134.41 22.5827 137.33 24.8728 137.688 28.0806L140.728 55.3654",
			stroke: "#7D818A",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.582 121.375L70.6992 117.171C68.2462 117.044 66.3612 114.952 66.4885 112.499L69.6123 52.3867C69.7396 49.9337 71.8316 48.0487 74.2847 48.176L155.168 52.3793C157.621 52.5066 159.506 54.5986 159.378 57.0517L156.254 117.164C156.127 119.617 154.035 121.502 151.582 121.375Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M151.582 121.375L70.6992 117.171C68.2462 117.044 66.3612 114.952 66.4885 112.499L69.6123 52.3867C69.7396 49.9337 71.8316 48.0487 74.2847 48.176L155.168 52.3793C157.621 52.5066 159.506 54.5986 159.378 57.0517L156.254 117.164C156.127 119.617 154.035 121.502 151.582 121.375Z",
			stroke: "#7D818A",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.0135 55.3646L75.0894 43.8218C74.1271 42.5773 72.6509 41.8301 71.1537 41.8301H48.1006C45.6248 41.8301 43.8282 43.837 44.0874 46.3128L45.0355 55.3646L45.071 55.7033L51.6288 118.307C51.8882 120.783 54.1052 122.79 56.581 122.79H148.276C150.752 122.79 152.548 120.783 152.289 118.307L146.166 59.8473C145.906 57.3716 143.689 55.3646 141.213 55.3646H84.0135Z",
			fill: "#FBC828"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.4539 97.3718C94.9472 95.4373 94.687 93.8795 94.6728 92.6994C94.6589 91.5193 94.9489 90.437 95.544 89.4534C95.8814 88.863 96.3055 88.3552 96.8173 87.9288C97.3284 87.503 97.784 87.0518 98.1844 86.5762C98.5841 86.1013 98.8869 85.5678 99.0935 84.9778C99.2995 84.3877 99.2785 83.6174 99.0295 82.6663C98.6088 81.06 97.8721 79.9365 96.8193 79.2973C95.7666 78.6578 94.6332 78.338 93.4205 78.338C91.6822 78.338 90.6125 78.8224 90.2101 79.7891C89.8073 80.7565 89.7386 82.06 90.0045 83.6994H83.6601C83.2394 82.0932 83.1191 80.6339 83.3007 79.322C83.4816 78.0108 83.9358 76.8957 84.6627 75.9774C85.3893 75.0598 86.3686 74.3542 87.6009 73.8628C88.8321 73.3709 90.268 73.125 91.9078 73.125C95.4488 73.125 98.4327 73.8465 100.86 75.2891C103.287 76.7325 104.926 79.0761 105.776 82.3225C106.051 83.3722 106.184 84.2898 106.178 85.0767C106.171 85.8635 106.037 86.5769 105.779 87.2161C105.52 87.8552 105.152 88.4541 104.675 89.0113C104.198 89.5692 103.644 90.1427 103.011 90.7327C102.436 91.2906 101.989 91.8072 101.671 92.2821C101.353 92.7577 101.147 93.258 101.056 93.7823C100.964 94.307 100.96 94.8567 101.045 95.4299C101.129 96.004 101.266 96.652 101.455 97.3725H95.4539V97.3718ZM97.7434 106.864L96.0562 100.421H102.696L104.383 106.864H97.7434Z",
			fill: "#B38600"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.0352 55.3652L45.0707 55.704",
			stroke: "#262626",
			strokeWidth: .157745,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.288 118.307L146.165 59.8473C145.905 57.3716 143.688 55.3646 141.212 55.3646H84.0125L75.0884 43.8218C74.1261 42.5773 72.6499 41.8301 71.1527 41.8301H48.0996",
			stroke: "#262626",
			strokeWidth: .157745,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.9204 65.8967V68.4981C38.9204 68.4981 43.1664 86.3105 43.9949 88.6924C44.8234 91.0743 41.0951 114.013 41.0951 114.013H28.6682L30.2453 88.4854L16.7135 112.332L5.61133 105.78C5.61133 105.78 16.4093 85.4657 16.7135 81.7976C17.0176 78.1292 15.93 61.2324 15.93 61.2324L38.9204 65.8967Z",
			fill: "#357DE8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.6126 62.5859C22.6126 62.5859 23.8713 80.4091 22.9781 83.5417C22.0848 86.6742 11.5684 109.293 11.5684 109.293",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.2386 88.0966C29.7156 96.7345 29.1929 105.372 28.6699 114.01H34.1248L32.1703 83.541C32.0582 84.3004 31.8174 85.3281 31.2703 86.4409C30.9414 87.1102 30.5749 87.6603 30.2386 88.0966Z",
			fill: "#1775AF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.2377 73.2873L26.228 71.8202H27.2046C27.816 71.8202 28.2502 71.2248 28.0633 70.6425C28.0185 70.5029 27.8885 70.4084 27.7418 70.4061C27.1182 70.3952 26.5972 70.3668 26.2114 70.3397C25.2938 70.2753 24.8267 70.2404 24.4284 70.0985C23.7746 69.8658 23.6859 69.6327 23.0172 69.3994C22.6125 69.2581 22.2409 69.2032 21.9367 69.1843C20.4504 67.9103 19.2394 66.4873 18.3726 64.9258L16.5164 71.7427C16.4683 71.7322 16.577 72.3683 16.5462 72.3924C17.5807 72.8943 18.4288 73.1552 19.3508 73.4709C19.4443 73.8313 19.5957 74.2347 19.8461 74.6422C20.2342 75.2739 20.6692 75.6069 21.4903 76.2345C21.6535 76.3595 21.5282 76.2562 23.5595 77.3713C23.7496 77.4756 24.1076 77.6724 24.364 77.5292C24.5771 77.4099 24.6553 77.0915 24.6618 77.0631C24.6966 76.9137 24.6831 76.7857 24.6682 76.7071C24.7149 76.7457 24.7864 76.7975 24.8816 76.8419C25.1387 76.9615 25.6129 77.0455 25.8981 76.7653C26.1498 76.5177 26.1054 76.1312 26.0953 76.0411C26.0773 75.8826 26.0245 75.7583 25.9825 75.678L26.3435 75.8223C26.601 75.9253 26.894 75.8846 27.1138 75.7156C27.5267 75.3979 27.5216 74.7736 27.1033 74.463L26.979 74.3705L27.671 74.5297C27.9359 74.5907 28.212 74.4921 28.3783 74.2774C28.6184 73.9664 28.5551 73.5186 28.2377 73.2873Z",
			fill: "#1775AF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.1794 36.4176C38.1794 36.4176 47.744 55.3138 48.8198 57.4898C49.8956 59.6658 57.7531 68.4754 57.7531 68.4754L52.7894 71.7397C50.671 69.9479 48.5526 68.1557 46.4342 66.3638C45.0454 65.1196 43.6563 63.6916 42.3278 62.0515C34.7521 52.6988 33.5033 41.8345 33.3613 35.8184L38.1794 36.4176Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.7494 51.39C45.5733 52.6704 45.1655 54.5297 44.1435 56.5597C43.295 58.2452 42.0163 59.7546 41.2193 60.6129C41.0808 60.4842 40.616 60.0218 40.5124 59.2587C40.4233 58.6022 40.6523 58.0992 40.7454 57.919L44.7262 49.084L45.7494 51.39Z",
			fill: "#FF7769"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.1236 23.2402C28.4895 23.8963 27.8984 24.2676 27.4648 24.4878C26.2891 25.0846 25.5822 25.9934 25.301 27.3084C25.0731 28.3737 25.1567 29.4979 25.51 30.5266C25.6895 31.0489 25.9388 31.5479 26.2532 32.0024C26.5597 32.4462 26.8744 32.7951 26.7179 33.3844C26.5082 34.1754 25.4419 34.4247 24.903 34.949C24.2374 35.5967 23.8824 36.537 23.8486 37.4556C23.8279 38.0165 23.917 38.5944 24.1991 39.0798C24.5487 39.6814 25.1445 40.0658 25.7312 40.408C26.3623 40.7758 26.975 41.1759 27.6227 41.5139",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.6094 23.7344C40.2238 24.3542 40.8735 25.0466 40.9585 25.9151C40.9934 26.2704 40.9284 26.6281 40.8362 26.9733C40.6679 27.6023 40.4081 28.2042 40.2492 28.8356C40.1263 29.3237 40.0653 29.8403 40.1839 30.3294C40.2912 30.7728 40.5409 31.1698 40.8298 31.5227C41.6519 32.5281 42.597 33.2252 42.7883 34.5947C42.8927 35.3402 42.8059 36.0996 42.6711 36.8401C42.5875 37.3001 42.4777 37.7729 42.1935 38.1442C41.6702 38.8284 40.6842 39.0628 39.8827 39.2254",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.5678 22.2407C32.9293 22.237 32.3734 22.2553 32.1681 22.2743C29.5084 22.5188 27.0198 24.015 26.2343 26.673C25.8742 27.8914 25.9406 28.9228 26.0571 29.4932C26.3579 30.9653 27.3477 31.5191 27.0953 32.5943C27.0439 32.8134 26.9775 32.9062 26.4714 33.6355C25.317 35.299 24.7385 36.1336 24.685 36.2762C24.1826 37.6166 24.7002 39.235 25.4877 40.2018C25.9813 40.8077 26.6801 41.3317 27.6299 41.6613C29.2879 42.2368 34.3146 44.2424 38.8986 41.5058C40.0337 40.8284 41.8988 39.715 42.394 37.6223C43.004 35.0443 41.1752 32.5011 40.8924 32.1079C40.2193 31.172 40.072 31.3921 39.7014 30.7357C38.9288 29.3675 39.3512 27.8839 39.7478 26.4745C40.1336 25.1036 39.9893 24.352 39.7451 23.9259C39.107 22.8125 37.3825 22.5727 35.9927 22.3793C35.0527 22.2492 33.9641 22.2431 33.5678 22.2407Z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.834 36.0918C38.2202 37.2946 40.2177 39.1139 41.2143 40.1846C42.9604 42.0609 44.0291 44.2118 44.8258 45.8156C45.3515 46.8735 45.7325 47.7897 45.9907 48.4564L40.4122 60.6116L34.834 36.0918Z",
			fill: "#FDB6D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0923 36.0254H34.8349C34.8349 36.0254 41.1389 40.6507 42.5165 44.6894C43.8945 48.7284 38.9006 66.7527 38.9006 66.7527C35.4886 66.8425 31.5065 66.705 27.1078 66.0925C21.0527 65.2494 15.9237 63.7455 11.8945 62.2429C12.7722 58.1074 13.6932 54.6364 14.4577 51.9903C16.612 44.5339 17.9276 42.2227 19.817 40.3398C21.5696 38.5936 23.3168 37.7129 23.8496 37.4572C26.3999 36.232 28.7439 36.0359 30.0923 36.0254Z",
			fill: "#FDB6D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.8966 41.5039C38.8966 41.5039 39.1198 51.0753 38.2395 54.5446C37.3591 58.0138 35.1113 66.7516 35.1113 66.7516H38.8997C38.8997 66.7516 40.9578 59.0236 41.1132 57.0816C41.2687 55.1401 41.4811 51.8002 41.2196 50.3633C40.9581 48.9264 40.4229 45.8742 40.0693 44.6236C39.715 43.373 38.8966 41.5039 38.8966 41.5039Z",
			fill: "#FF97CB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.6132 53.3358C22.0814 53.6396 20.2892 54.752 19.5223 57.0042C18.3164 60.5466 20.9219 64.8092 21.0706 64.9857L12.998 62.9848C12.998 62.9848 13.205 57.2373 13.8523 55.1141C14.4996 52.991 17.6325 49.582 17.6325 49.582L22.6132 53.3358Z",
			fill: "#FF97CB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.4744 38.3879C31.1642 38.393 30.0983 37.3348 30.0935 36.0249L30.0742 30.9203L34.8184 30.9023L34.8377 36.007C34.8425 37.3168 33.7843 38.3828 32.4744 38.3879Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.8298 34.5775L31.7402 32.9902C31.7714 33.2578 31.9472 34.5108 33.0491 35.3762C33.7526 35.9287 34.4924 36.055 34.8338 36.0909L34.8298 34.5775Z",
			fill: "#FF7769"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.9558 29.339C29.9409 29.2618 29.7376 29.1453 29.675 29.1057C29.5696 29.0383 29.4555 28.9844 29.3362 28.9461C29.1049 28.8716 28.8505 28.8543 28.6127 28.9089C28.1399 29.0173 27.7205 29.4146 27.6416 29.9013C27.5959 30.1842 27.6612 30.4765 27.7825 30.736C27.9647 31.1262 28.2737 31.4541 28.6466 31.6692C28.9559 31.8473 29.3078 31.9479 29.6635 31.9693C29.7346 31.9737 30.4639 31.9567 30.4584 31.9286C30.2911 31.0652 30.1234 30.2021 29.9558 29.339Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.307 29.3896C29.3632 29.7707 29.6979 31.7793 31.5087 33.1986C31.8424 33.4601 34.0597 35.1981 36.0887 34.3499C38.6959 33.2599 38.4113 28.9777 38.393 28.7457C38.3311 27.9615 38.1478 25.6524 36.2357 24.4205C34.6748 23.4151 32.9839 23.7847 32.7441 23.8412C32.4914 23.9005 30.8814 24.307 29.8961 25.8855C29.0015 27.3179 29.2149 28.7663 29.307 29.3896Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.914 28.7474C36.956 29.0817 37.2138 29.3246 37.4899 29.2901C37.7659 29.2555 37.9556 28.9564 37.9136 28.6221C37.8716 28.2878 37.6138 28.0449 37.3378 28.0794C37.0617 28.114 36.872 28.4131 36.914 28.7474Z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.9004 29.1263C33.9424 29.4606 34.2001 29.7035 34.4762 29.669C34.7523 29.6344 34.9419 29.3353 34.8999 29.001C34.8579 28.6667 34.6002 28.4238 34.3241 28.4584C34.048 28.4929 33.8584 28.792 33.9004 29.1263Z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.0035 29.248L36.4655 29.872C36.5505 29.9868 36.5187 30.1494 36.3967 30.2236L35.9727 30.4817",
			stroke: "#262626",
			strokeWidth: .248287,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.8902 30.7016C32.9373 31.0766 33.2797 31.3428 33.6547 31.2954C34.0296 31.248 34.2959 30.9059 34.2485 30.5309C34.2014 30.1559 33.8589 29.8897 33.484 29.9371C33.109 29.9842 32.8431 30.3263 32.8902 30.7016Z",
			fill: "#FF7769"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.6397 31.0557C29.642 30.9805 29.6485 30.471 29.2396 30.1035C28.9195 29.8156 28.5469 29.7966 28.4453 29.7949",
			stroke: "#262626",
			strokeWidth: .248287,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.2782 30.2022C29.2555 30.1988 28.9815 30.1605 28.7901 30.3678C28.6326 30.5382 28.6471 30.7489 28.6502 30.7838",
			stroke: "#262626",
			strokeWidth: .248287,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.247 28.9225C29.247 28.9225 29.584 28.9523 29.8381 29.2046C30.0921 29.4567 30.1822 29.8885 30.1822 29.8885C30.8316 29.8096 32.3189 29.5356 33.6681 28.3646C34.3994 27.7298 34.8458 27.0436 35.109 26.5487C35.3549 26.7699 35.7746 27.1022 36.3684 27.3582C37.1431 27.6922 38.1108 27.8521 38.2392 27.592C38.2629 27.5439 38.2368 27.4043 38.184 27.1255C38.165 27.0246 38.145 26.8752 38.0959 26.7323C38.0001 26.4525 37.8754 26.1825 37.7267 25.9268C37.4286 25.4153 37.032 24.9611 36.5652 24.5969C36.2621 24.3605 35.9288 24.162 35.5744 24.0113C34.4499 23.533 32.8883 23.5327 31.5443 24.2494C31.5443 24.2494 30.0437 25.0498 29.3822 26.6161C29.1549 27.1543 29.0976 27.6926 29.0834 27.8792C29.055 28.2488 29.0966 28.4903 29.1528 28.6759C29.1847 28.7809 29.2203 28.8649 29.247 28.9225Z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.0387 29.6184C38.1684 29.6021 38.2934 29.6255 38.4045 29.6756C38.3913 30.0432 38.3561 30.4889 38.2751 30.9618C38.2531 30.9669 38.2321 30.974 38.2094 30.977C37.8345 31.0241 37.492 30.7582 37.4449 30.3833C37.3975 30.0076 37.6634 29.6655 38.0387 29.6184Z",
			fill: "#FF7769"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.2431 31.4062L35 31.9137",
			stroke: "#262626",
			strokeWidth: .248287,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.0685 68.627L18.8587 74.0019C17.3249 74.4097 16.412 75.9838 16.8199 77.5179C17.2277 79.0516 18.8021 79.9645 20.3358 79.5563L40.3502 74.2336L39.0685 68.627Z",
			fill: "#1775AF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8199 76.8414C16.4121 75.3077 17.3246 73.7336 18.8583 73.3254L58.4969 62.7832L59.9741 68.3377L20.3355 78.8802C18.8018 79.288 17.2277 78.3755 16.8199 76.8414Z",
			fill: "#1868DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.237 73.286L26.2273 71.819H27.2039C27.8153 71.819 28.2495 71.2235 28.0626 70.6412C28.0178 70.5017 27.8878 70.4072 27.7411 70.4048C27.1175 70.394 26.5965 70.3655 26.2107 70.3384C25.2931 70.2741 24.826 70.2392 24.4277 70.0972C23.7739 69.8645 23.6852 69.6315 23.0165 69.3981C22.6118 69.2569 22.2402 69.202 21.936 69.183C21.7402 69.0153 21.5502 68.8446 21.3642 68.6719L18.8438 73.2979C19.0111 73.3544 19.1794 73.411 19.3501 73.4696C19.4436 73.83 19.595 74.2334 19.8454 74.6409C20.2335 75.2727 20.6685 75.6056 21.4895 76.2333C21.6528 76.3583 21.5275 76.255 23.5588 77.3701C23.7489 77.4744 24.1069 77.6712 24.3633 77.5279C24.5764 77.4087 24.6546 77.0903 24.6611 77.0618C24.6959 76.9124 24.6824 76.7844 24.6675 76.7058C24.7142 76.7444 24.7857 76.7963 24.8809 76.8406C25.138 76.9602 25.6122 77.0442 25.8974 76.7641C26.1491 76.5165 26.1047 76.13 26.0946 76.0399C26.0766 75.8813 26.0238 75.757 25.9818 75.6768L26.3428 75.8211C26.6003 75.924 26.8933 75.8834 27.1131 75.7144C27.526 75.3966 27.5209 74.7724 27.1026 74.4617L26.9783 74.3693L27.6703 74.5285C27.9352 74.5894 28.2113 74.4909 28.3776 74.2761C28.6177 73.9652 28.5544 73.5174 28.237 73.286Z",
			fill: "#3041BF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.9242 39.2266C14.0509 43.0261 8.00394 50.0753 8.01173 57.2719C8.01647 61.7343 10.3489 65.6985 11.1185 67.0066C14.0956 72.0665 19.9769 72.6891 22.0859 73.8594L24.4861 70.424C19.2917 67.1038 16.0988 62.466 17.0212 56.6507C18.1993 49.2244 24.7882 45.8765 25.4179 45.5699L22.9242 39.2266Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1786 45.8105L19.7611 50.3031L18.5684 52.1322C17.5495 51.8172 16.1245 51.2519 14.6283 50.2089C13.2937 49.2788 12.345 48.2772 11.7129 47.4984C12.2017 46.9355 12.6901 46.3732 13.1786 45.8105Z",
			fill: "#FF7769"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8945 45.2587L22.6129 53.3363C25.2116 47.9959 27.2277 44.0829 28.671 41.3491C29.3 40.1574 30.9012 37.1431 29.9524 36.1841C29.7096 35.9386 28.9749 35.8911 27.5058 35.7956C26.3375 35.7201 25.6438 35.6788 24.7096 35.7956C24.7096 35.7956 23.6037 35.9342 22.4056 36.3522C20.5944 36.9846 16.4884 40.1523 11.8945 45.2587Z",
			fill: "#FDB6D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.1582 114.012V122.254H44.3737L44.0282 119.883C44.0282 119.883 39.8842 117.557 39.2392 117.028C38.5946 116.498 37.904 115.462 37.7658 115.14C37.6276 114.818 37.7658 114.012 37.7658 114.012H31.1582Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.4922 117.12C30.6534 117.075 30.897 117.034 31.1598 117.108C31.8356 117.3 32.0131 118.083 32.3054 118.501L39.8858 118.588C39.8699 118.203 39.8539 117.819 39.8384 117.435C40.233 117.307 40.6273 117.179 41.0219 117.051C41.8484 117.973 42.6522 118.508 43.2598 118.831C44.1927 119.328 45.4023 119.721 45.8948 120.562C46.1336 120.97 46.1458 121.384 46.1472 121.461C46.1509 121.674 46.156 121.974 45.9409 122.173C45.781 122.322 45.5761 122.343 45.4805 122.346C40.588 122.315 35.6957 122.285 30.8031 122.254C30.6314 122.254 30.4922 122.115 30.4922 121.943V117.12Z",
			fill: "#FFC001"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.4968 123.198H31.0751C30.753 123.198 30.4922 122.937 30.4922 122.615V121.969H46.0798V122.615C46.0798 122.938 45.8186 123.198 45.4968 123.198Z",
			fill: "#5D1113"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.1582 114.012H37.7661L37.7082 114.835H31.1582V114.012Z",
			fill: "#FF7769"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.83302 106.98L3.56641 114.032L14.8731 120.873L15.8053 118.666C15.8053 118.666 13.4633 114.531 13.1859 113.744C12.9085 112.957 12.854 111.713 12.9024 111.366C12.9512 111.018 13.4864 110.401 13.4864 110.401L7.83302 106.98Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.65335 109.293C5.81458 109.338 6.04458 109.429 6.23054 109.629C6.7095 110.143 6.45613 110.905 6.48933 111.413L12.9302 115.411C13.1155 115.074 13.3008 114.737 13.4864 114.401C13.8902 114.495 14.2939 114.59 14.6977 114.685C14.9277 115.902 15.3386 116.775 15.6905 117.367C16.2315 118.275 17.063 119.237 17.0492 120.212C17.0424 120.684 16.8381 121.045 16.7999 121.111C16.6925 121.296 16.5417 121.555 16.2545 121.614C16.0408 121.658 15.8548 121.57 15.7711 121.524C11.6011 118.965 7.43133 116.406 3.26125 113.847C3.11425 113.758 3.0675 113.567 3.15625 113.42L5.65335 109.293Z",
			fill: "#FFC001"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3467 122.263L3.00791 114.798C2.73253 114.631 2.64412 114.273 2.81077 113.997L3.14544 113.443L16.4822 121.513L16.1475 122.066C15.9808 122.341 15.6225 122.43 15.3467 122.263Z",
			fill: "#5D1113"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.83466 106.98L13.488 110.401L13.0125 111.075L7.4082 107.685L7.83466 106.98Z",
			fill: "#FF7769"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.6288 41.6602C27.495 43.181 27.1278 45.396 26.0723 47.866C25.0019 50.3705 23.6308 52.1851 22.6129 53.3368C19.04 50.6442 15.4671 47.9517 11.8945 45.2591",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.8613 41.1855C39.4087 42.4937 39.9178 43.9584 40.3263 45.5741C41.8154 51.4649 41.2866 56.6749 40.5607 60.1865",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4868 37.1719C24.4868 37.1719 21.8535 37.3548 20.0671 38.7917C18.2806 40.2286 15.834 42.7141 15.834 42.7141",
			stroke: "white",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3467 50.877C18.3569 52.3047 17.8193 53.6325 17.5182 54.5654C17.046 56.0297 16.9366 57.2054 16.9075 57.5712C16.834 58.4956 16.7286 59.8231 17.1832 61.3477C17.3736 61.9869 17.842 63.2625 17.842 63.2625",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1914 71.9529C19.2229 72.4196 19.3418 73.1974 19.8255 73.9852C20.2137 74.617 20.6486 74.9499 21.4697 75.5776C21.6333 75.7026 21.5076 75.5993 23.539 76.7144C23.729 76.8187 24.087 77.0155 24.3435 76.8722C24.5565 76.753 24.6348 76.4346 24.6412 76.4061C24.6761 76.2568 24.6625 76.1287 24.6476 76.0501C24.6944 76.0887 24.7658 76.1406 24.861 76.1849C25.1181 76.3045 25.5927 76.3885 25.8775 76.1084C26.1292 75.8608 26.0852 75.4743 26.0747 75.3842C26.0564 75.2257 26.0039 75.1014 25.9616 75.0211L26.3226 75.1654C26.5804 75.2684 26.8731 75.228 27.0932 75.0587C27.5062 74.741 27.5011 74.1167 27.0827 73.8061L26.9584 73.7136L27.6504 73.8728C27.9153 73.9338 28.1911 73.8352 28.3574 73.6204C28.5979 73.3098 28.5345 72.8624 28.2175 72.6307L26.2078 71.1637H27.1847C27.7961 71.1637 28.2303 70.5682 28.0434 69.9859C27.9987 69.8463 27.8686 69.7518 27.7219 69.7495C27.098 69.7386 26.5774 69.7102 26.1916 69.6831C25.2739 69.6187 24.8068 69.5838 24.4085 69.4419C23.7547 69.2092 23.666 68.9761 22.9977 68.7428C22.4351 68.5466 21.9314 68.5141 21.592 68.5179L19.1914 71.9529Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.6476 76.0486C24.3079 75.6536 23.873 75.2082 23.329 74.7655C22.8663 74.3892 22.4198 74.0924 22.0215 73.8594",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.9607 75.0197C25.6226 74.62 25.1901 74.1685 24.6484 73.7173C24.0492 73.2187 23.4714 72.8494 22.9785 72.5781",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9576 73.7107C26.5237 73.2795 25.9675 72.7975 25.2748 72.3385C24.8212 72.038 24.3859 71.7979 23.9883 71.6055",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.9785 101.29L31.1723 86.3983C31.8837 85.1054 32.2261 83.6417 32.1618 82.1676L31.885 75.8066",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.6416 71.8314C52.1925 72.0908 51.618 71.9367 51.3585 71.4876L49.9366 69.0243C49.6771 68.5752 49.8312 68.0007 50.2804 67.7412C50.7295 67.4818 51.304 67.6359 51.5635 68.0851L52.9858 70.5483C53.2446 70.9974 53.0908 71.5719 52.6416 71.8314Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.0885 71.3588C53.6394 71.6182 53.0649 71.4641 52.8054 71.015L51.0596 67.9911C50.8001 67.542 50.9543 66.9675 51.4034 66.708C51.8526 66.4486 52.427 66.6027 52.6865 67.0519L54.4323 70.0757C54.6918 70.5248 54.5377 71.0993 54.0885 71.3588Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.5121 70.5716C55.0629 70.8311 54.4885 70.6769 54.229 70.2278L52.3975 67.0556C52.138 66.6064 52.2922 66.032 52.7413 65.7725C53.1905 65.513 53.7649 65.6672 54.0244 66.1163L55.8559 69.2885C56.1154 69.738 55.9612 70.3125 55.5121 70.5716Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.4232 70.0641C55.9328 70.2331 55.3983 69.9726 55.2292 69.4821L54.0359 66.019C53.8669 65.5285 54.1274 64.994 54.6178 64.825C55.1083 64.6559 55.6428 64.9164 55.8118 65.4069L57.0052 68.87C57.1742 69.3605 56.9137 69.895 56.4232 70.0641Z",
			fill: "#F7A99C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.3021 66.7793C51.0867 67.0032 51.0105 67.2061 50.9786 67.327C50.8252 67.9045 51.2784 68.5945 52.1913 69.9515C52.3989 70.2601 52.7068 70.7001 52.7068 70.7001V70.6994",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.7419 65.7715C52.5895 65.9195 52.4124 66.1417 52.349 66.4412C52.2667 66.8303 52.4286 67.1081 53.3154 68.6436C53.6087 69.1513 54.02 69.8636 54.02 69.8636",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.3582 65.0078C54.2582 65.1023 54.1085 65.2727 54.0584 65.5166C54.0096 65.7523 54.076 65.9481 54.1048 66.0338C54.2566 66.4837 54.5963 67.51 55.0654 68.8707",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M84.7784 76.2948C94.8775 72.2788 99.8089 60.8363 95.7929 50.7372C91.777 40.638 80.3344 35.7066 70.2353 39.7226C60.1362 43.7386 55.2048 55.1811 59.2208 65.2802C63.2367 75.3794 74.6793 80.3107 84.7784 76.2948Z",
			fill: "#CDEBF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.5063 36.0273C65.3633 36.0273 55.5195 45.8711 55.5195 58.0142C55.5195 70.1572 65.3633 80.001 77.5063 80.001C89.6494 80.001 99.4931 70.1572 99.4931 58.0142C99.4931 45.8711 89.6494 36.0273 77.5063 36.0273ZM77.5063 76.4308C67.335 76.4308 59.0897 68.1855 59.0897 58.0142C59.0897 47.8428 67.335 39.5975 77.5063 39.5975C87.6777 39.5975 95.923 47.8428 95.923 58.0142C95.923 68.1855 87.6777 76.4308 77.5063 76.4308Z",
			fill: "#1868DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.3955 71.0053C81.1628 70.7977 81.009 70.5016 80.9887 70.166C80.9473 69.4899 81.4615 68.9086 82.1376 68.8673C83.3658 68.7921 84.5792 68.4496 85.6472 67.8768C86.8405 67.237 87.6193 66.4447 87.9773 66.0294C88.4017 65.5366 89.2854 64.5116 89.6069 62.9917C90.054 60.875 89.1218 59.0486 88.7005 58.3613C88.3462 57.7841 88.5274 57.0291 89.1046 56.6751C89.6818 56.3212 90.4375 56.5024 90.7908 57.0792C91.5051 58.2438 92.6128 60.6264 92.0061 63.4988C91.5546 65.6351 90.3494 67.0334 89.8349 67.6306C89.2617 68.2952 88.2713 69.2524 86.8066 70.0383C85.429 70.777 83.8665 71.2187 82.2877 71.3153C81.9469 71.3356 81.6309 71.2157 81.3955 71.0053Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.7363 41.5486C67.1112 40.5232 71.6285 37.4235 78.1636 37.5096C84.4835 37.5929 88.8145 40.6049 90.2023 41.66",
			stroke: "#262626",
			strokeWidth: .14047,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.1141 13.4025C44.3224 12.3213 44.5727 11.4667 44.8647 10.8391C45.1567 10.2111 45.594 9.66841 46.1763 9.21045C46.5146 8.93371 46.8808 8.70981 47.2751 8.53841C47.6687 8.36736 48.0379 8.17733 48.3827 7.968C48.7265 7.759 49.0314 7.50868 49.2969 7.21772C49.5622 6.92675 49.7461 6.51587 49.8484 5.98407C50.0215 5.08644 49.8951 4.41102 49.469 3.95814C49.0429 3.5056 48.4908 3.21362 47.8133 3.08321C46.8419 2.89589 46.1207 3.03782 45.6505 3.5073C45.1794 3.97745 44.8102 4.66168 44.5419 5.55998L40.9961 4.87643C41.1692 3.9788 41.4727 3.19126 41.9073 2.51482C42.3415 1.83872 42.8787 1.29574 43.5183 0.886899C44.1574 0.478054 44.884 0.209444 45.6976 0.0810666C46.5106 -0.0473112 47.3757 -0.0232613 48.2923 0.153554C50.2711 0.534962 51.7554 1.23951 52.7455 2.2662C53.735 3.29356 54.0554 4.71384 53.7058 6.52807C53.5927 7.11474 53.4342 7.61606 53.2306 8.03303C53.0263 8.44967 52.7709 8.8138 52.4641 9.12543C52.1568 9.43672 51.7991 9.71482 51.391 9.95904C50.9825 10.2036 50.5269 10.4482 50.0235 10.6934C49.5601 10.9275 49.1794 11.1534 48.8807 11.3712C48.5819 11.5893 48.34 11.8325 48.1558 12.1008C47.9708 12.3694 47.8292 12.6607 47.731 12.9741C47.6324 13.2877 47.5444 13.6464 47.4668 14.0492L44.1141 13.4025ZM42.9817 18.6864L43.6758 15.0857L47.3865 15.8007L46.6925 19.4014L42.9817 18.6864Z",
			fill: "#1868DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1511 25.0321C14.0417 24.1598 14.02 23.4492 14.0861 22.9004C14.1521 22.3517 14.3496 21.8314 14.6785 21.3396C14.8668 21.0456 15.0894 20.7851 15.3461 20.5575C15.6026 20.3302 15.8359 20.0944 16.0456 19.8502C16.255 19.6063 16.4243 19.3408 16.5537 19.0542C16.6828 18.7676 16.7207 18.4103 16.6668 17.9814C16.5761 17.2572 16.3129 16.7759 15.8773 16.5378C15.442 16.2997 14.9505 16.215 14.4038 16.2837C13.62 16.3823 13.1078 16.6682 12.8673 17.1411C12.6262 17.6146 12.5154 18.2253 12.5344 18.9736L9.67415 19.333C9.58303 18.6088 9.6186 17.936 9.78085 17.3148C9.9431 16.6939 10.2161 16.1489 10.6006 15.6801C10.9847 15.2117 11.4694 14.8279 12.0554 14.5288C12.6407 14.23 13.3033 14.0342 14.0424 13.9414C15.6388 13.7409 16.9399 13.9079 17.9455 14.4424C18.9509 14.9769 19.5457 15.9758 19.7296 17.4391C19.7889 17.9123 19.793 18.3324 19.7415 18.6992C19.6896 19.066 19.586 19.4058 19.4302 19.7181C19.274 20.0304 19.0715 20.3302 18.8222 20.6167C18.5725 20.9036 18.2873 21.2021 17.9662 21.5127C17.6725 21.805 17.4395 22.0709 17.2667 22.31C17.094 22.5495 16.9707 22.7941 16.8972 23.0434C16.8233 23.293 16.7878 23.5491 16.7908 23.8113C16.7935 24.0738 16.8155 24.3678 16.8565 24.6926L14.1511 25.0321ZM14.5999 29.3227L14.2351 26.4178L17.2285 26.0418L17.5933 28.9467L14.5999 29.3227Z",
			fill: "#1868DB"
		})
	]
});
export default SvgTableNoSearchResultsIllustration;
